/*
 * Vangnet voor afbeeldingen van de Shopify-CDN (25-10-2026).
 *
 * De beeldverkleiner van de CDN geeft bij een koude aanvraag -- een formaat
 * dat nog niet eerder gemaakt is -- af en toe een 502, terwijl dezelfde URL
 * een tel later gewoon 200 geeft. Gemeten op 25-10-2026: 12 van 50 koude
 * aanvragen. Een browser probeert een mislukte afbeelding nooit opnieuw, dus
 * bleef er een kapot icoontje staan: in een gewone browser zat het formaat
 * meestal al in de cache, in een incognitovenster niet.
 *
 * Mislukt een <img> van de CDN, dan laadt dit het origineel zonder
 * width/height/crop. Dat origineel serveert de CDN zonder bewerking en faalt
 * niet. Het is groter dan nodig, maar dat is alleen in dit zeldzame geval en
 * altijd beter dan een leeg vak. theme.js vangt het load-event daarna zelf op
 * en haalt is-loading weg.
 *
 * Het error-event bubbelt niet, vandaar de capture-fase op document.
 */
(function () {
  'use strict';

  function origineel(url) {
    var u = new URL(url, location.href);
    ['width', 'height', 'crop'].forEach(function (p) { u.searchParams.delete(p); });
    return u.href;
  }

  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!(img instanceof HTMLImageElement) || img.dataset.brandHerstel) return;
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('/cdn/shop/') < 0 || !/[?&](width|height|crop)=/.test(src)) return;

    img.dataset.brandHerstel = '1';
    // Een <picture> kiest uit zijn <source>-elementen, dus die moeten weg
    // voordat de img zijn eigen src gebruikt.
    if (img.parentElement && img.parentElement.tagName === 'PICTURE') {
      img.parentElement.querySelectorAll('source').forEach(function (s) { s.remove(); });
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = origineel(src);
  }, true);
})();
